module.exports = __webpack_public_path__ + "static/rebote-game-710a3f9563fe154f3a4e25ff3413894f.png";